import React, { useState } from 'react'
import { Popover } from 'antd'

export interface PickerOption {
	value: string
	label: string
	icon?: React.ReactNode
}

interface Props {
	value?: string
	onChange?: (v: string) => void
	options: PickerOption[]
	placeholder?: string
	autoOpen?: boolean
	onDismiss?: () => void
}

const SimplePickerPopover = ({
	value,
	onChange,
	options,
	placeholder = 'Vybrať',
	autoOpen,
	onDismiss
}: Props) => {
	const [open, setOpen] = useState(() => autoOpen ?? false)

	const handleSelect = (optValue: string) => {
		onChange?.(optValue)
		setOpen(false)
	}

	const handleVisibleChange = (next: boolean) => {
		setOpen(next)
		if (!next && !value) {
			onDismiss?.()
		}
	}

	const selectedOption = options.find((opt) => opt.value === value)

	const content = (
		<div style={{ padding: '4px 0', minWidth: 160 }}>
			{options.map((opt) => {
				const isSelected = value === opt.value
				const optBg = isSelected ? '#eff6ff' : 'transparent'
				const optColor = isSelected ? '#1d4ed8' : '#374151'
				const optWeight = isSelected ? 600 : 400
				return (
					<button
						key={opt.value}
						type={'button'}
						onClick={() => handleSelect(opt.value)}
						style={{
							display: 'block',
							width: '100%',
							textAlign: 'left',
							padding: '8px 16px',
							background: optBg,
							border: 'none',
							borderRadius: 6,
							cursor: 'pointer',
							fontSize: 13,
							fontWeight: optWeight,
							color: optColor
						}}
					>
						{opt.icon}{opt.label}
					</button>
				)
			})}
		</div>
	)

	const triggerBorder = selectedOption ? '1px solid #d1d5db' : '1px dashed #d1d5db'
	const triggerColor = selectedOption ? '#374151' : '#9ca3af'
	const triggerContent = selectedOption
		? <>{selectedOption.icon}{selectedOption.label}</>
		: `+ ${placeholder}`

	return (
		<Popover
			visible={open}
			onVisibleChange={handleVisibleChange}
			content={content}
			trigger={'click'}
			placement={'bottomLeft'}
			getPopupContainer={(trigger) => (trigger.closest('.ant-modal-body') as HTMLElement) ?? document.body}
		>
			<span
				style={{
					display: 'inline-flex',
					alignItems: 'center',
					gap: 4,
					padding: '4px 12px',
					border: triggerBorder,
					borderRadius: 20,
					fontSize: 13,
					color: triggerColor,
					cursor: 'pointer',
					background: '#fff',
					userSelect: 'none'
				}}
			>
				{triggerContent}
			</span>
		</Popover>
	)
}

export default SimplePickerPopover
